import { exportsModule } from '@cian/mf-registry/browser';
import { ConfigurationError } from '@cian/peperrors/shared';

import { buildAPIRuntime } from '../services/buildAPIRuntime';

const microfrontendName = document.currentScript?.getAttribute('data-header-microfrontend-name');
const imageVersion = document.currentScript?.getAttribute('data-header-image-version');

if (!microfrontendName || !imageVersion) {
  throw new ConfigurationError({
    message:
      'Header API Runtime scope is missing. Не заданы data-header-microfrontend-name или data-header-image-version.',
    domain: 'header-frontend.api-runtime.scope',
  });
}

const scope = { microfrontendName, imageVersion };

exportsModule({
  api: () => buildAPIRuntime(scope),
});
